module.exports = __webpack_public_path__ + "9ac8db59f412783797f0a608bf45c2dd.png";